import { defineComponent } from 'vue';
import { payReq } from '@/api/index';
import app from '@/widget/app';
import { hostPath, payApi2 } from '@utils/basePath';
import { appPort, wechatPort, queryToString, getCookie, setCookie } from '@/widget/index';
export default defineComponent({
    props: {
        orderInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        module: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            payType: 1,
            wechat: wechatPort(),
            isApp: appPort(),
            openId: ''
        };
    },
    methods: {
        pay() {
            if (!this.module) {
                this.$toast('无订单类型');
                return;
            }
            this.$showLoading();
            if (appPort()) {
                // app 中走app 支付
                this.payOrder();
                return;
            }
            if (this.payType === 2) {
                let url = window.encodeURIComponent(`${hostPath}/learn/list/exercise?depId=${this.$route.query.depId}`);
                payReq
                    .getAliPaySign({
                    params: {
                        module: this.module
                    },
                    query: {
                        orderId: this.orderInfo.orderId,
                        returnUrl: url
                    }
                })
                    .then(res => {
                    this.$hideLoading();
                    if (res.code === 200 && res.data) {
                        document.write(res.data);
                    }
                    else {
                        this.$toast(res.message);
                    }
                });
            }
            else {
                if (this.openId) {
                    this.wechatPay();
                }
                else if (!this.$route.query.code && wechatPort()) {
                    this.wechatReady();
                }
                else {
                    this.wechatCode();
                }
            }
        },
        closeTip() {
            this.$store.commit('SET_PAYTIP', false);
        },
        wechatCode() {
            if (this.openId) {
                this.wechatPay();
            }
            else {
                payReq
                    .getWechatCodeInfo({
                    code: this.$route.query.code
                })
                    .then(res => {
                    if (res.code === 200) {
                        this.openId = res.data.openId;
                        let now = Number(new Date().getTime());
                        localStorage.setItem('openId', this.openId);
                        setCookie('openId', this.openId, Infinity);
                        this.wechatPay();
                    }
                    else {
                        this.$hideLoading();
                        this.$toast(res.message);
                    }
                });
            }
        },
        wechatPay() {
            payReq
                .getWechatSign({
                params: { module: this.module },
                query: {
                    orderId: this.orderInfo.orderId,
                    openId: this.openId
                }
            })
                .then(res => {
                this.$hideLoading();
                if (res.code === 200) {
                    let sign = res.data;
                    window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
                        appId: sign.appId,
                        timeStamp: sign.timeStamp,
                        nonceStr: sign.nonceStr,
                        package: sign.packageValue,
                        signType: sign.signType,
                        paySign: sign.paySign
                    }, res => {
                        if (res.err_msg === 'get_brand_wcpay_request:ok') {
                            this.$emit('payCallBack');
                        }
                        else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                            this.wechatAuth();
                        }
                        else {
                            this.$emit('payCallBack');
                        }
                    });
                }
                else {
                    this.$toast(res.message);
                }
            });
        },
        wechatReady() {
            if (typeof WeixinJSBridge === 'undefined') {
                document.addEventListener('WeixinJSBridgeReady', this.setEnv, false);
            }
            else {
                this.setEnv();
            }
        },
        setEnv() {
            this.payType = 1;
            if (!this.$route.query.code) {
                this.wechatAuth();
            }
        },
        wechatAuth() {
            let base = payApi2 + '/wechat/auth?redirectURI=';
            let query = this.$route.query;
            delete query.code;
            let str = queryToString(query);
            let redirectUrl = window.encodeURIComponent(`${window.location.protocol}//${window.location.host + window.location.pathname}?${str}`);
            window.location.replace(base + redirectUrl);
        },
        checkType(id) {
            if (id === this.payType) {
                return;
            }
            if (this.isApp) {
                this.payType = id;
            }
            else {
                this.$toast(id === 1 ? '当前环境不支持微信支付' : '当前环境不支持支付宝支付');
            }
        },
        payOrder() {
            app.appPay.call(this, {
                platform: this.payType === 1 ? 'wechat' : 'alipay',
                module: this.module,
                type: 'app',
                orderId: this.orderInfo.orderId
            });
        }
    },
    mounted() {
        if (!this.isApp) {
            if (this.wechat) {
                this.payType = 1;
                // 判断本地是否有 openId
                this.openId = getCookie('openId') || localStorage.getItem('openId');
                if (!this.openId) {
                    this.wechatReady();
                }
            }
            else {
                this.payType = 2;
            }
        }
        else {
            ;
            window.payCallback = () => {
                this.$store.commit('SET_PAYTIP', false);
                this.$hideLoading();
                this.$emit('payCallBack');
            };
        }
    }
});
